import { render, staticRenderFns } from "./AccountMembershipProductView.vue?vue&type=template&id=22764e8c"
import script from "./AccountMembershipProductView.vue?vue&type=script&lang=js"
export * from "./AccountMembershipProductView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports